<div class="number">{{number}}</div>
<div class="label">{{label}}</div>

